import React, { Component } from 'react';
import './RCFGraphs.css';
import { t } from 'i18next';

import LineGraph from '../LineGraph/LineGraph';

class RCFGraphs extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  componentDidMount() {
    const { data } = this.props;
    this.formatData(data);
  }

  componentWillReceiveProps(props) {
    const { data } = props;
    this.formatData(data);
  }

  formatData(data) {
    if (Object.keys(data).length > 0) {
      const allRawData = {
      };
      Object.keys(data).forEach((property) => {
        allRawData[property] = data[property].map((value) => ({
          x: new Date(value['x-axis']),
          y: parseFloat(value.raw, 10),
        }));
      });
      this.setState({
        allRawData,
      });
    }
  }

  render() {
    const { allRawData } = this.state;
    const { yAxisLabel } = this.props;
    return (
      <div className="board">
        {allRawData && Object.keys(allRawData).map((property) => (
          <div className="graph-row"
            key={property}
          >
            <div className="graph-row-content deviation">
              <div className="graph-row-title">
                {`${property} ${t('tensorAnalytics.graphs.deviationTitle')}`}
              </div>
              <LineGraph data={allRawData[property]}
                textLine={t('tensorAnalytics.graphs.raw')}
                yAxisTitle={yAxisLabel || `${property} ${t('tensorAnalytics.graphs.deviationAxis')}`}
                colorLine="#0074B7"
                xAt0
              />
            </div>
          </div>
        ))}
      </div>
    );
  }
}

export default RCFGraphs;
